import Assets from '@/shared/services/assets';
import useEventBus from '@/shared/composables/useEventBus';

export default function useEmailValidation() {
  const eventBus = useEventBus();
  const emailRegex = new RegExp(Assets.assets.validation.email_js, 'i');
  /**
   * Check if email matches the validation regex
   * @param {string} value - Email that is being validated
   * @returns {boolean} - True if valid, otherwise false
   */
  function validEmail(value) {
    if (!value) return false;
    return emailRegex.test(value);
  }

  /**
   * Validate email and display error if invalid
   * @param {string} value - Email
   * @returns {boolean} - True if valid
   */
  function validateEmail(value) {
    if (!value) {
      eventBus.error('Please enter a valid email, including the domain (e.g., user@example.com)');
      return false;
    }

    if (!validEmail(value)) {
      eventBus.error('Please enter a valid email, including the domain (e.g., user@example.com)');
      return false;
    }

    return true;
  }

  return {
    validEmail,
    validateEmail,
  };
}
